import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import vi from './vi.json'
import en from './en.json'

import eSimVI from './esim/vi.json'
import eSimEN from './esim/en.json'
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      ...en,
      es: { ...eSimEN }
    }
  },
  vi: {
    translation: {
      ...vi,
      es: { ...eSimVI }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    // Fixed lng for SSR; AppLayoutWrapper syncs from server `lang` (URL), not browser detect.
    fallbackLng: "vi",
    lng: "vi",
    supportedLngs: ["en", "vi"],
    interpolation: { escapeValue: false },
    detection: {
      // Avoid client LanguageDetector overriding lng before hydrate (text mismatch).
      order: [],
      caches: [],
    },
  });

export default i18n;